import { input } from "@angular/core";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { CalendarData } from "../../modules/home/calendar/CalendarData";
import { OptBean } from "../../modules/s25-opt/s25.opt.component";
import { OptUtil } from "../../modules/s25-opt/s25.opt.util";
import { Item } from "../../pojo/Item";
import { CalendarOptModelBean } from "./calendar.with.options.component";

interface S25CalendarState {
    readonly comptype: OptUtil.CompType;
    readonly compsubject: Item.Subject;
    readonly modelBean: CalendarOptModelBean | undefined;
    readonly optBean: OptBean | undefined;
    readonly calData: CalendarData | undefined;
}

export const S25CalendarStore = signalStore(
    withState<S25CalendarState>({
        comptype: "home",
        compsubject: "event",
        modelBean: undefined,
        optBean: undefined,
        calData: undefined,
    }),
    withMethods((store) => ({
        setComptype(comptype: OptUtil.CompType) {
            patchState(store, { comptype });
        },
        setCompsubject(compsubject: Item.Subject) {
            patchState(store, { compsubject });
        },
        setModelBean(modelBean?: CalendarOptModelBean) {
            patchState(store, { modelBean });
        },
        setOptBean(optBean?: OptBean) {
            patchState(store, { optBean });
        },
        setCalData(calData: CalendarData) {
            // TODO: consider parsing dates, etc. before inserting into the store
            patchState(store, { calData });
        },
    })),
);
